// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const TaskSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M104 24c-2.3 2.3-2.3 2.4-2 13.7l.2 8.3h-19c-18 0-19.1.1-22.2 2.3-1.9 1.2-4.2 3.6-5.2 5.3-1.8 3-1.9 8.2-1.8 108.5 0 99.3.1 105.4 1.8 108.3 1 1.7 3.3 4.1 5.2 5.3l3.3 2.3h85.6c83.7 0 85.7-.1 88.9-2 1.8-1.1 4.1-3.4 5.2-5.2 2-3.2 2-5.3 2-108.8s0-105.6-2-108.8c-4-6.6-6.3-7.2-27.2-7.2H198V36c0-15.4 4.6-14-48-14-42.7 0-44.1.1-46 2zm78 30v16h-64V38h64v16zm-80 18c0 15.4-4.6 14 48 14s48 1.4 48-14V62h32v200H70V62h32v10z" />
      <path d="M179.7 132.2c-1.9 2.9-9.6 15.3-17.1 27.5L148.8 182h-5.2l-5.1-.1-9.9-13c-5.5-7.1-10.5-13.4-11.3-14-1-.9-2.8 0-7.8 3.7-3.5 2.7-6.5 5.1-6.5 5.4 0 1.6 23.8 30.5 26.4 32.1 2.6 1.6 5 1.9 14.5 1.9 9.7 0 11.9-.3 14.6-2 2.5-1.5 7.9-9.5 20.9-30.4 9.7-15.6 17.6-28.8 17.6-29.3s-1.7-1.9-3.7-3.1c-2.1-1.2-5.2-3.1-7-4.3l-3.2-2.1-3.4 5.4z" />
    </svg>
  )
}
